export const SEND_ORGANIZATION_REQUEST = 'SEND_ORGANIZATION_REQUEST';
export const ONBOARD_CX_ORG = 'ONBOARD_CX_ORG';
export const GET_ORGANIZATION = 'GET_ORGANIZATION';
export const ONBOARDING_BUY_PLAN = 'ONBOARDING_BUY_PLAN';
